const faqDataTr = [
  {
    text: "Shipping & Delivery", // değişmesin
    faqs: [
      {
        id: "1",
        question: "Sipariş Verdikten Sonra Ne Olur?",
        answer:
          "Siparişiniz onaylandıktan sonra size bir e-posta gönderilir. Ardından ürününüz hazırlanır ve anlaşmalı kargo firmalarımız (DHL, UPS ve FEDEX) aracılığıyla size ulaştırılır.",
      },
      {
        id: "2",
        question: "Kargo Ücreti Ne Kadar?",
        answer:
          "Kargo ücreti ödemezsiniz, kargo Mukemel ailesinden siz değerli müşterilerimize bir hediyedir.",
      },
      {
        id: "3",
        question: "Siparişim Bana Nasıl Ulaşacak?",
        answer:
          "Sipariş oluşturulup ödemeniz onaylandıktan sonra heykel siparişleri 3 iş günü içinde hazırlanır. İş günleri Pazartesi'den Cuma'ya kadardır, resmi tatiller hariçtir. Cumartesi, Pazar ve resmi tatillerde işlem ve kargo yapılmaz. Bu günlerde verilen siparişler bir sonraki iş günü işleme alınır. Teslimat, taşıyıcı firmalara (DHL, UPS & FEDEX) bağlıdır ve hava durumu nedeniyle gecikebilir. Kara Cuma, Siber Pazartesi gibi kampanya dönemlerinde teslimatlar normalden uzun sürebilir.",
      },
    ],
  },
  {
    text: "Exchanges & Returns", // değişmesin
    faqs: [
      {
        id: "1",
        question: "Ürünüm Kırık Teslim Edildiyse Ne Yapmalıyım?",
        answer:
          "Politikalarımıza göre, paketi kırık teslim alan müşteriler, teslimattan sonraki 24 saat içinde bizimle iletişime geçmelidir. PARFÜM hariç. Bu sürenin ardından ürünün sorunsuz teslim edildiği kabul edilir ve sorumluluk kabul edilmez.",
      },
      {
        id: "2",
        question: "Ürünü Beğenmediysem Ne Yapmalıyım?",
        answer:
          "Politikalarımıza göre, müşterilere (PARFÜM SİPARİŞLERİ HARİÇ) gönderim tarihinden itibaren 14 gün içinde iade hakkı tanınır. 14 gün geçtiyse maalesef iade alamıyoruz. İadelerde siparişinizden belirli bir ücret kesilebilir ve her durum ayrı ayrı değerlendirilir. Ürün kullanılmamış, orijinal ambalajında ve etiketi üzerinde olmalıdır. Kargo ve gümrük ücretleri alıcıya aittir.",
      },
      {
        id: "3",
        question: "Kişiselleştirme Yapılan Ürünleri İade Edebilir Miyim?",
        answer:
          "Eğer ürün kişiselleştirme ile sipariş edildiyse iadesi kabul edilmemektedir.",
      },
    ],
  },
  {
    text: "Product Orders", // değişmesin
    faqs: [
      {
        id: "1",
        question: "Toptan Satış Mümkün mü?",
        answer:
          "Toptan alışveriş imkanı sunuyoruz. Detaylı bilgi için bizimle customer.support@mukemel.com adresi üzerinden iletişime geçebilirsiniz.",
      },
      {
        id: "2",
        question: "Ödeme Yöntemleri Nelerdir?",
        answer:
          "Tüm online işlemlerimizde güvenilir ve onaylı bir ödeme altyapısı kullanıyoruz.",
      },
      {
        id: "3",
        question: "Ürün Stokta Yoksa Ne Yapmalıyım?",
        answer:
          "Stokta olmayan ürünler için lütfen customer.support@mukemel.com adresinden bizimle iletişime geçin. E-posta adresinizi bekleme listesine ekleyelim. Ürün tekrar stoklara girdiğinde size bildirim gönderilecektir.",
      },
    ],
  },
  {
    text: "Perfume Policies", // değişmesin
    faqs: [
      {
        id: "1",
        question: "Ödeme Yöntemleri Nelerdir?",
        answer:
          "Tüm online işlemlerimizde güvenilir ve onaylı bir ödeme altyapısı kullanıyoruz.",
      },
      {
        id: "2",
        question: "Toptan Satış Mümkün mü?",
        answer:
          "Toptan alışveriş imkanı sunuyoruz. Detaylı bilgi için bizimle customer.support@mukemel.com adresi üzerinden iletişime geçebilirsiniz.",
      },
      {
        id: "3",
        question: "Sipariş Verdikten Sonra Ne Olur?",
        answer:
          "Siparişiniz onaylandıktan sonra size bir e-posta gönderilir. Ardından ürününüz hazırlanır ve anlaşmalı kargo firmalarımız (DHL, UPS ve FEDEX) aracılığıyla size ulaştırılır.",
      },
      {
        id: "4",
        question: "Kargo Ücreti Ne Kadar?",
        answer:
          "Kargo ücreti ödemezsiniz, kargo Mukemel ailesinden siz değerli müşterilerimize bir hediyedir.",
      },
      {
        id: "5",
        question: "Parfüm Siparişim Bana Nasıl Ulaşacak?",
        answer:
          "Siparişiniz oluşturulup ödemeniz onaylandıktan sonra, parfümünüzün üretim süreci başlar ve 14 iş günü içinde size ulaşır. İş günleri Pazartesi'den Cuma'ya kadardır, resmi tatiller hariçtir. Cumartesi, Pazar ve resmi tatillerde işlem ve kargo yapılmaz. Bu günlerde verilen siparişler bir sonraki iş günü işleme alınır. Teslimat, taşıyıcı firmalara (DHL, UPS & FEDEX) bağlıdır ve hava koşullarına göre gecikebilir. Kara Cuma, Siber Pazartesi gibi dönemlerde siparişler normalden uzun sürebilir.",
      },
      {
        id: "6",
        question: "Ürün Stokta Yoksa Ne Yapmalıyım?",
        answer:
          "Parfüm ürünlerinde stok tutulmaz. Her ürün müşteri için özel olarak üretilir. Bu nedenle teslimat süresi 14 iş günüdür.",
      },
      {
        id: "7",
        question: "Ürünüm Kırık Teslim Edildiyse Ne Yapmalıyım?",
        answer:
          "Parfüm siparişleri özel korumalı kutularda hazırlandığı için kırık gelmesi mümkün değildir. Bu nedenle kırık teslimat sorumluluğu kabul edilmemektedir.",
      },
      {
        id: "8",
        question: "Parfüm Siparişimi Beğenmezsem Ne Yapmalıyım?",
        answer:
          "Parfüm ürünlerinde iade, kargonun ulaşmasından itibaren 48 saat içinde mümkündür. Bu süreden sonra iade kabul edilmez. İade durumunda siparişten bazı ücretler kesilebilir. İade edilecek kutu, üzerindeki ısıya duyarlı güvenlik bandı açılmamış olmalıdır. Bu bant açılmışsa iade kabul edilmez. Ayrıca size hediye olarak 2 tester parfüm gönderilmiştir, onları her durumda sizde kalacak şekilde kullanabilirsiniz. Kargo ve gümrük masrafları alıcıya aittir.",
      },
      {
        id: "9",
        question: "Kişiselleştirme Yapılan Ürünleri İade Edebilir Miyim?",
        answer: "Kişiselleştirme içeren ürünlerde iade kabul edilmemektedir.",
      },
    ],
  },
];
export default faqDataTr;
